import {
  SelectedContractActions,
  SET_MASTER_CONTRACT,
  SET_MASTER_CONTRACT_DATE,
} from '../../actions/master-contract.actions';
import { OrderBuilderActions, RESET_BUILDER } from '../../../../actions/order-builder.actions';
import { Moment } from 'moment';
import { ISalesDocument } from '@cemex-core/cmx-api/models/product/models/sales-document.interface';
import { RESET as SPEC_RESET, SpecificationActions } from '../../actions/specification.actions';

export interface MasterContractState {
  selectedContract: ISalesDocument | null;
  selectedDate: { date: Date; time: Moment } | null;
}

export const initialState: MasterContractState = {
  selectedContract: null,
  selectedDate: null,
};

export function masterContractReducer(
  state = initialState,
  action: SelectedContractActions | OrderBuilderActions | SpecificationActions,
): MasterContractState {
  switch (action.type) {
    case SET_MASTER_CONTRACT_DATE: {
      return {
        ...state,
        selectedDate: action.payload,
      };
    }
    case SET_MASTER_CONTRACT: {
      return {
        ...state,
        selectedContract: action.payload,
      };
    }
    case RESET_BUILDER:
    case SPEC_RESET: {
      return {
        ...state,
        selectedContract: null,
        selectedDate: null,
      };
    }
    default: {
      return state;
    }
  }
}
